import { MotifToast } from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import "./Toast.scss";
interface ToastProps {
  variantType?: "success" | "error";
  message?: string;
  timer?: number;
}

export function Toast({
  variantType = "success",
  message = "updated successfully",
  timer = 5000,
}: ToastProps) {
  const [showToastSuccess, setShowToastSuccess] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setShowToastSuccess(false);
    }, timer);
  }, [timer]);
  if (!showToastSuccess) {
    return <></>;
  }
  return (
    <div className="product-preview-toast">
      <MotifToast variant={variantType}>
        <div slot="toast-supporting-text">{message}</div>
      </MotifToast>
    </div>
  );
}
